import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import React, { useState } from "react";
import {
  convertFromRaw,
  EditorState,
  RawDraftContentState,
  Editor as PlainEditor,
} from "draft-js";

const shitposts: RawDraftContentState[] = [
  {
    entityMap: {},
    blocks: [
      {
        key: "637gr",
        text: "Shitposts go here",
        type: "unstyled",
        depth: 0,
        inlineStyleRanges: [],
        entityRanges: [],
        data: {},
      },
    ],
  },
  {
    entityMap: {},
    blocks: [
      {
        key: "637gr",
        text: "Shitposts go here too",
        type: "unstyled",
        depth: 0,
        inlineStyleRanges: [],
        entityRanges: [],
        data: {},
      },
    ],
  },
];

function Shitposts() {
  return (
    <>
      {shitposts.map((post) => (
        <div className="postDiv">
          <PlainEditor
            readOnly
            editorState={EditorState.createWithContent(convertFromRaw(post))}
            onChange={() => {}}
          />
        </div>
      ))}
    </>
  );
}

function Shitposter() {
  const [editorState, setEditorState] = useState<RawDraftContentState>();
  const onChange = (content: RawDraftContentState) => {
    setEditorState(content);
  };

  const postShit = () => {
    fetch("mongodb+srv://hegbotchat.3m6uh.mongodb.net/hegbot", {
      method: "POST",
      body: JSON.stringify({
        name: (document.getElementById("name") as HTMLTextAreaElement)
          .textContent,
        post: JSON.stringify(editorState),
        date: new Date(),
      }),
    });
  };

  return (
    <>
      <p>
        <strong>Name: </strong>
        &nbsp;
        <input id="name" type="text" size={50} />
        &nbsp;
        <button
          type="button"
          style={{ padding: "12px 12px" }}
          onClick={() => postShit()}
        >
          Send
        </button>
      </p>
      <div className="editorDiv">
        <Editor
          wrapperClassName="demo-wrapper"
          editorClassName="demo-editor"
          toolbar={{
            options: [
              "inline",
              "fontSize",
              "fontFamily",
              "colorPicker",
              "link",
              "embedded",
              "emoji",
              "image",
            ],
          }}
          onContentStateChange={onChange}
        />
      </div>
    </>
  );
}

export default function Shitposting() {
  return (
    <>
      <Shitposts />
      <hr />
      <Shitposter />
    </>
  );
}
